// extracted by mini-css-extract-plugin
export default {"testimonial":"TestimonialOne_testimonial__QJALP","thumb":"TestimonialOne_thumb__96tVs","reviews":"TestimonialOne_reviews__ZOB68","clientInfo":"TestimonialOne_clientInfo__SBFAm"};